<template>
  <div class="flight-pad-detail-title">
    <span class="flight-pad-detail-title__iata">
      <span>{{ itinerary.firstDeparture.iataCode }}</span> -
      <delta-overlay
        :text="itinerary.lastArrival.iataCode"
        :delta="get_itinerary_delta(itinerary)"
      />
    </span>
    <div class="d-flex align-items-center">
      <div class="d-flex align-items-center mr-2">
        <flight-pad-stops :itinerary="itinerary" />
        <span
          v-if="itinerary.duration"
          style="font-size: 40px; line-height: 0"
        >&middot;</span>
        <flight-pad-duration
          v-if="itinerary.duration"
          :duration="itinerary.duration"
          :font_size="16"
          full
        />
      </div>
      <img
        class="flight-pad-detail-title__logo"
        :src="`https://static.vadobay.com/airlines-logos/200x100/${carrier_iata(itinerary)}.png`"
        :alt="carrier_iata(itinerary)"
      />
    </div>
  </div>
</template>

<script>
import { carrier_iata } from "../script/utilities";
import { get_itinerary_delta } from "@liveflight/utilities/flight-duration";
import FlightPadDuration from "@liveflight/components/blocks/flight-pad/flight-pad-duration.vue";
import FlightPadStops from "@liveflight/components/blocks/flight-pad/flight-pad-stops.vue";
import DeltaOverlay from "@liveflight/components/blocks/flight-pad/delta-overlay.vue";

export default {
  name: "flight-pad-detail-title",

  components: {
    "flight-pad-duration": FlightPadDuration,
    "flight-pad-stops": FlightPadStops,
    "delta-overlay": DeltaOverlay,
  },

  props: {
    // itinerario di volo rappresentato nel titolo del pad
    itinerary: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    get_itinerary_delta,
    carrier_iata,
  },
};
</script>

<style lang="scss">

  .flight-pad-detail-title {
    display: flex;
    align-items: center;

    &__iata {
      font-size: $font-size-xl;
      color: $primary;
      font-weight: $vb-font-weight-semibold;
      margin-right: $grid-gutter-width / 3;
    }

    &__logo {
      max-height: 30px;

      @include media-breakpoint-down(md) {
        display: none;
      }
    }
  }
</style>